import { Anchor } from "@components/Anchor";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { SUPPORT_EMAIL_URL } from "@constants";
import { useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";

export const FiveTwoNineDisclaimer = () => {
  const { theme } = useTheme();

  return (
    <>
      <Body>{i18n.t(Translations.FiveTwoNineDisclaimerTitle)}</Body>
      <Spacing size={SpacingSizes.M} />

      <Body>
        If you intend to make a qualified withdrawal, please reach out to{" "}
        <Anchor href={SUPPORT_EMAIL_URL} style={{ color: theme.link.default }}>
          support@futuremoney.co
        </Anchor>{" "}
        for details
      </Body>
      <Spacing size={SpacingSizes.M} />

      <Body>{i18n.t(Translations.FiveTwoNineDisclaimerFooter)}</Body>
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
